let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("4rU0s")).then(() => parcelRequire('dPuzR'));